module.exports = __webpack_public_path__ + "img/twitter.01a68c34.svg";